import { render } from "./SidebarItem.vue?vue&type=template&id=23fbdf45&scoped=true&ts=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=23fbdf45&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=23fbdf45&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fbdf45"]])

export default __exports__